(function () {
    var componentId = 'hostDirectorDashboardPdpaConsentWidget';
    var app = angular.module('app');

    function controller(directorDashboardSvc) {
        var vm = this;
        vm.loading = 0;
        vm.result = [];
        vm.latest = null;

        function loadData() {
            vm.loading++;
            directorDashboardSvc.getPdpaConsentStatistics()
                .success(function (data) {
                    vm.statistics = data;
                }).finally(function () {
                    vm.loading--;
                });
        }

        loadData();
    }

    app.component(componentId, {
        templateUrl: require('/App/host/views/directorDashboard/pdpaConsentWidget.html'),
        controller: ['abp.services.app.directorDashboard', controller],
        controllerAs: 'vm'
    });
})();
